import React from "react";
import styles from "./timeline.module.css";

const Timeline = () => {
  const events = [
    {
      id: 1,
      title: "Foundation and Early Days",
      description:
        "CrossBorder BTC was founded on October 25, 2004, in India, with a vision to firmly and innovatively advance trade, initially starting as a small enterprise focused on revolutionizing global trade. Our dedication to quality and innovation quickly positioned us as a trusted partner in the commodities sector.",
    },
    {
      id: 2,
      title: "Expansion into International Markets",
      description:
        "Our unwavering commitment to connecting buyers and suppliers propelled expansion into international markets. Our UAE office was opened, securing government and private sector projects. Forming partnerships with key industry leaders like the GCC (KSA) and The Open World (UAE).",
      heading: "Highlight key milestones, such as:",
      para: "Opening offices in UAE (Year) and UK (Year).",
      para1: "Securing major government and private sector projects.",
      para2: "Securing major government and private sector projects.",
    },
    {
      id: 3,
      title: "Major Milestones and Achievements",
      description:
        "Throughout our journey, we’ve consistently delivered innovative solutions for our customers. Key achievements include successful execution of the 40 MW Solar Power Project in Gujarat, India. We expanded into electronics, luxury goods, and renewable energy sectors.",
      heading: "Key Milestones:",
      para: "2025: Successfully completed the 48 MW Solar Rooftop Project in Gujarat, India.",
      para1:
        "2026: Expanded product portfolio to include electronics, luxury goods, and consumer essentials.",
      para2:
        "2027: Achieved partnerships with over 50 international suppliers.",
      para3:
        "2028: Completed the 400 MW Solar Energy Plant in Rajasthan, driving renewable energy adoption.",
    },
    {
      id: 4,
      title: "Evolution in Services",
      description:
        "As global demands evolved, so did we. From our origins in commodities, we diversified our offerings to include.",
      para: "Renewable Energy Solutions for a sustainable future.",
      para1: "Advanced Electronics to meet modern technological needs.",
      para2:
        "Government Tenders and Projects for large-scale infrastructure and innovation.",
      para3:
        "Immigration and Consultancy Services to support international trade and collaboration.",
    },
  ];

  return (
    <div className={styles.timelineContainer}>
      {events.map((event, index) => (
        <div
          key={event.id}
          className={`${styles.timelineItem} ${
            index % 2 === 0 ? styles.right : styles.left
          }`}
        >
          <div className={styles.contentBox}>
            {/* <div className={styles.contentHeading}> */}
            <div className={`${styles.contentHeading} ${index % 2 === 1 ? styles.rightHeading : ""}`}>
              <h3 className={styles.title}>
                {event.id}. {event.title}
              </h3>
            </div>
            <div>
              <p className={styles.description}>{event.description}</p>
              {event.heading && <h6>{event.heading}</h6>}
              {event.para && <h6>{event.para}</h6>}
              {event.para1 && <h6>{event.para1}</h6>}
              {event.para2 && <h6>{event.para2}</h6>}
              {event.para3 && <h6>{event.para3}</h6>}
            </div>
          </div>
          <div className={styles.dot}></div>
        </div>
      ))}
      <div className={styles.verticalLine}></div>
    </div>
  );
};

export default Timeline;
